export const EAUTOMATE_DESCRIPTION =
  'Read the dealer’s e-automate SQL Server database through this entity’s agents.'
